import router from '../router'

function jsSDK(params, msg, type, money) {
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', function() {
        onBridgeReady(params, msg, type, money)
      }, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', function() {
        onBridgeReady(params, msg, type, money)
      })
      document.attachEvent('onWeixinJSBridgeReady', function() {
        onBridgeReady(params, msg, type, money)
      })
    }
  } else {
    onBridgeReady(params, msg, type, money)
  }
}

function onBridgeReady(params, msg, type, money) {
  window.WeixinJSBridge.invoke(
    'getBrandWCPayRequest', {
      'appId': params.appId, // 公众号名称，由商户传入
      'timeStamp': params.timeStamp, // 时间戳，自1970年以来的秒数
      'nonceStr': params.nonceStr, // 随机串
      'package': params.package,
      'signType': params.signType, // 微信签名方式：
      'paySign': params.paySign // 微信签名
    },
    function(res) {
      if (res.err_msg == 'get_brand_wcpay_request:fail') {
        //支付失败
        router.push({
          name: "payResult",
          query: {
            result: 0,
            msg: "缴费失败，请重新缴费",
            type: type,
            money: money
          }
        });
      }
      if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        //支付取消

      }
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        //支付成功
        //window.location.href = this.$api.payUrl;
        router.push({
          name: "payResult",
          query: {
            result: 1,
            msg: msg,
            type: type
          }
        });
      }

    }
  )
}

export default jsSDK



// WEBPACK FOOTER //
// ./src/utils/wxPay.js